if(window.innerWidth < 750) {
    const mainButton = document.querySelector('.intersection-main-button');
    const bottomButton = document.querySelector('.intersection-bottom-button');

    // Intersection Observer API for smooth transition (optional)
    const observer = new IntersectionObserver(entries => {
      if (!entries[0].isIntersecting) {
        bottomButton.style.transform = 'translateY(0)';
      } else {
        bottomButton.style.transform = 'translateY(150%)';
      }
    });

    observer.observe(mainButton); // Observe the main button
  }

  document.addEventListener('DOMContentLoaded', function () {
    function isIE() {
      const ua = window.navigator.userAgent;
      const msie = ua.indexOf('MSIE ');
      const trident = ua.indexOf('Trident/');

      return msie > 0 || trident > 0;
    }

    if (!isIE()) return;
    const hiddenInput = document.querySelector('#{{ product_form_id }} input[name="id"]');
    const noScriptInputWrapper = document.createElement('div');
    const variantSwitcher =
      document.querySelector('variant-radios[data-section="{{ section.id }}"]') ||
      document.querySelector('variant-selects[data-section="{{ section.id }}"]');
    noScriptInputWrapper.innerHTML = document.querySelector(
      '.product-form__noscript-wrapper-{{ section.id }}'
    ).textContent;
    variantSwitcher.outerHTML = noScriptInputWrapper.outerHTML;

    document.querySelector('#Variants-{{ section.id }}').addEventListener('change', function (event) {
      hiddenInput.value = event.currentTarget.value;
    });
  });
